<template>
    <CContainer class="mt-4">
        <CRow>
            <CCol col="sm-6">
                <CInput 
                    label="Buscar"
                    :value.sync="searchWord" 
                    @keyup.enter="getData(1, searchWord)">
                    <template #prepend-content>
                        <a href="#" @click="getData(1)">
                            <i class="bi bi-arrow-clockwise"></i>
                        </a>
                    </template>
                    <template #append-content>
                        <a href="#" @click="getData(1, searchWord)">
                            <i class="bi bi-search"></i>
                        </a>
                    </template>
                </CInput>
            </CCol>
            <CCol col="sm-6">
                <CButton
                    color="success"
                    class="mt-4"
                    @click="goTo({}, 'agregarContacto')">
                    <CIcon class="" name="cil-plus"/>
                    <span class="p-2 align-middle">Agregar</span>
                </CButton>
            </CCol>
        </CRow>
        <CDataTable
            hover
            :items="items"
            :fields="fields"
            :items-per-page="itemsPerPage" 
            :responsive=true >
            <template #dependencia="{item}">
                <td>
                    <h4>{{ item.responsable }}</h4>
                    <span>{{ item.dependencia }}</span>
                </td>
            </template>
            <template #telefono="{item}">
                <td>
                    <div v-if="Boolean(item.telefono)"><CIcon name="cil-phone"/> {{ item.telefono }} - {{ item.extension }}</div>
                    <div v-if="Boolean(item.telefono)"><CIcon name="cil-tag"/> {{ phoneType[item.tipo_Telefono] }}</div>
                    <div v-if="Boolean(item.correo_Electronico)"><CIcon name="cil-envelope-closed"/> <a @click="event => event.stopPropagation()" :href="`mailto:${item.correo_Electronico}`">{{ item.correo_Electronico }}</a></div>
                </td>
            </template>
            <template #direccion="{item}">
            <td>
                <div><i class="bi bi-geo-fill" style="height: 1rem; width: 1rem; display: inline-block;"></i> {{ item.direccion }}</div>
                <div v-if="Boolean(item.ciudad) && Boolean(item.departamento)"> <CIcon name="cil-map"/> {{ item.ciudad }} - {{ item.departamento }}</div>
            </td>
            </template>
            <template #estado="{item}">
                <td align="center">
                    <CIcon v-if="item.estado == 'A'" name="cil-smile" size="xl" class="text-success"/>
                    <CIcon v-if="item.estado == 'I'" name="cil-x-circle" class="text-danger"/>              
                </td>
            </template>
            <template #info="{item}">
                <td>
                    <a href="#"
                        class="mb-2"
                        @click="toggleDocument(item, $event)" >
                        <CIcon :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'"></CIcon>
                    </a>
                </td>
            </template>
            <template #details="{item}">
                <CCollapse class="my-3" :show="item._toggled">
                    <CRow>
                        <CCol col="sm-12">
                            <div class="d-flex justify-content-end">
                                <a href="#" 
                                    class="m-2" 
                                    @click="goTo(item, 'editarContacto')">
                                    <i class="bi bi-pencil-square text-warning h4"></i>
                                </a>
                                <a href="#" 
                                    class="m-2" 
                                    @click="tryDelete(item.id_Dependencia)">
                                    <i class="bi bi-trash text-danger h4"></i>
                                </a>
        
                                <!-- <CDropdown
                                    color="s3skyblue"
                                    toggler-text=""
                                    class="m-2" 
                                    size="sm" >
                                    <CDropdownItem>
                                        <CIcon name="cil-pencil" class="text-warning mr-2"></CIcon>
                                        <span>Editar</span>
                                        <a href="#">
                                            <span>Aqui puede ir texto</span>
                                        </a>
                                    </CDropdownItem>
                                    <CDropdownItem>
                                        <CIcon name="cil-trash" class="text-danger mr-2"></CIcon>
                                        <span>Borrar</span>
                                    </CDropdownItem>
                                </CDropdown>                         -->
        
                            </div>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol col="sm-6" class="ml-3">
                            <div>
                                <strong>Centro Costo: </strong>{{ item.codigo ? item.codigo : ''}}
                            </div>
                            <div>
                                <strong>Pedidos: </strong><CBadge :color="item.habilitado_Pedidos === 'V' ? 'success' : 'danger'"> {{item.habilitado_Pedidos === 'V' ? 'Activo' : 'Inactivo'}}</CBadge>
                            </div>
                            <div>
                                <strong>Presupuesto: </strong><CBadge :color="item.habilitado_Pedidos === 'V' ? 'success' : 'danger'"> {{item.activar_Presupuesto === 'V' ? 'Activo' : 'Inactivo'}}</CBadge>
                            </div>
                            <div>
                                <strong>Actualización: </strong>{{ item.fecha_Actualizacion ? moment(item.fecha_Actualizacion).format('DD/MM/YYYY HH:mm:ss') : '' }}
                            </div>
                        </CCol>
                    </CRow>
                </CCollapse>
            </template>
        </CDataTable>
        <CPagination 
            size="sm" 
            class="d-flex justify-content-center"
            :activePage.sync="page"
            :pages="pageCount"
            @update:activePage="(value, a) => getData(value, searchWord)" 
        />

        <CElementCover v-show="loading"/>
    </CContainer>
</template>
<script>
    import moment from "moment"
    import { formatter } from "../../general"
    import CONSTANTS from "../../constants"
    import { 
        dataGridDependencias 
    } from "../../apiDataGrids"
    import {
        borrarDependencia
    } from "../../api"

    const fields = [    
        { key: "dependencia", label: "Dependencia", _style:"text-align:center;" },
        { key: "telefono", label: "Contacto", _style:"text-align:center;" },
        { key: "direccion", label: "Dirección", _style:"text-align:center;" },
        { key: "estado", label: "Estado", _style:"text-align:center;" },
        { key: "info", label: "" }
    ]

    export default {
        name: "DependenciesDirectory",
        data() {
            return {
                formatter,
                loading: false,
                page: 1,
                pageCount: 1,
                itemsPerPage: 5,
                searchWord: "",
                fields,
                items: [],
                phoneType: {
                    "G": "General",
                    "P": "Personal",
                    "M": "Movil",
                    "T": "Trabajo",
                    "F": "Fax"
                },
                idDependency: ""
            }    
        },
        methods: {
            moment,
            async getData(page, search) {
                this.loading = true
                this.searchWord = search

                try {
                    const { count, results } = await dataGridDependencias(
                        this, 
                        this.selectedDirectory.id_Directorio,
                        page,
                        search
                    )
                    
                    this.pageCount = parseInt(count / this.itemsPerPage)
                    if (this.pageCount < (count / this.itemsPerPage)) {
                        this.pageCount++
                    }

                    this.items = results
                } catch (error) {
                    console.log(error)
                    this.$store.commit("setAlert", {
                        color: "danger",
                        message: "Error al cargar datos",
                        show: 5
                    })
                } finally {
                    this.loading = false
                }
            },
            goTo(item, destiny) {
                this.$store.commit("set", ["selectedDependency", {
                ...item,
                "id_Directorio": this.selectedDirectory.id_Directorio
                }])

                this.$router.push(
                {
                    path: `/administracion/archivo/directorio/${destiny}`
                }
                )
            },
            tryDelete(id) {
                this.idDependency = id

                CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar"
                CONSTANTS.configSimpleConfirm.confirmButtonColor = "red"

                this.$confirm("¿Confirma que desea borrar este registro?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
                    this.deleteDependency()
                }).catch(() => {
                    this.$alert("¡Se cancelo la acción!", "", "warning", CONSTANTS.configSimpleAlert)
                })
            },
            async deleteDependency() {
                this.loading = true

                try {
                    await borrarDependencia(this, this.idDependency)
                    const itemIndex = this.documents.findIndex(it => it.id_Dependencia == this.idDependency)
                    this.documents.splice(itemIndex, 1)
                    
                    this.$store.commit("setAlert", {
                        color: "success",
                        message: "Acción exitosa",
                        show: 5
                    })
                } catch (error) {
                    console.log(error)
                    this.$store.commit("setAlert", {
                        color: "danger",
                        message: CONSTANTS.messages.notDoneDelete,
                        show: 5
                    })
                } finally {
                    this.loading = false
                }
            },
            toggleDocument(item) {
                this.$set(item, "_toggled", !item._toggled)
                this.$nextTick(() => { })
            }
        },
        computed: {
            selectedDirectory() {
                return this.$store.state.selectedDirectory
            }
        },
        async mounted() {
            await this.getData()
        }
    }
</script>
